function checkImageExists(imageUrl, callback) {
    console.log('Checking image exists:', imageUrl);
    var img = new Image();
    img.onload = function () {
        callback(true);
    };
    img.onerror = function () {
        callback(false);
    };
    img.src = imageUrl;
}

function pollForImages() {
    var imageElements = document.querySelectorAll('.custom-thumbnail');

    imageElements.forEach(function (imageElement) {
        var imageUrl = imageElement.getAttribute('src');

        var intervalId = setInterval(function () {
            checkImageExists(imageUrl, function (exists) {
                if (exists) {
                    imageElement.src = imageUrl;
                    clearInterval(intervalId);
                }
            });
        }, 2000);
    });
}

document.addEventListener('turbo:load', function () {
    pollForImages();
});
